import { Component, Input } from '@angular/core';
import { ComingSoonComponent } from "../../../../shared/components/coming-soon/coming-soon.component";
import {AssetVersionPipe} from '../../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-copilot-more-wizard-options-tile',
  imports: [ComingSoonComponent, AssetVersionPipe],
  templateUrl: './copilot-more-wizard-options-tile.component.html',
  styleUrl: './copilot-more-wizard-options-tile.component.scss'
})
export class CopilotMoreWizardOptionsTileComponent {
  @Input() isExpiredUser: boolean = false;
  @Input() iconPath: string = '';
  @Input() description: string = '';
  isHovered: boolean = false;
}
